import { UserEntity } from '../../models'

export const SET_PROFILE = 'SET_PROFILE'
export const SET_PROFILE_LOADED = 'SET_PROFILE_LOADED'
export const SET_LOGINING = 'SET_LOGINING'
export const SET_ERROR_LOGIN = 'SET_ERROR_LOGIN'
export const LOGOUT = 'LOGOUT'

export interface AuthState {
  profile: UserEntity | null
  isProfileLoaded: boolean
  logining: boolean
  error: string
}

interface LogoutAction {
  type: typeof LOGOUT
}

interface SetErrorLoginAction {
  type: typeof SET_ERROR_LOGIN
  payload: string
}

interface SetProfileAction {
  type: typeof SET_PROFILE
  payload: UserEntity
}

interface SetProfileLoadedAction {
  type: typeof SET_PROFILE_LOADED
  payload: boolean
}

interface SetLoginingAction {
  type: typeof SET_LOGINING
  payload: boolean
}

export type AuthAction =
  | LogoutAction
  | SetErrorLoginAction
  | SetProfileAction
  | SetProfileLoadedAction
  | SetLoginingAction
